/*
 * 
 * key
 * 
 */
const key = 'QmlydGhkYXkgbGlzdA0K'

export default key